import React from 'react';
import { MDXProvider } from '@mdx-js/react';
import VideoContent from '../../mdx/services/video.mdx';
import './Videodetails.css';

const MdxHeading = ({ children, ...props }) => <h2 className="wedding-photography-details__heading" {...props}>{children}</h2>;
const MdxParagraph = ({ children, ...props }) => <p className="Videodetails__paragraph" {...props}>{children}</p>;

const Videodetails = () => (
  <section className="Videodetails">
    <div className="Videodetails__container" style={{ width: '100%' }}>
      <div className="Videodetails__content">
        <MDXProvider components={{
          h2: MdxHeading,
          p: MdxParagraph,
        }}>
          <VideoContent />
        </MDXProvider>
      </div>
    </div>
  </section>
);

export default Videodetails;
